export default __webpack_public_path__ + "static/sdc-dir-chore-logo-7244667ab18ad7e387d7e114e4c4c586.svg";